import withSuspense from "../../../../hocs/withSuspense";
import {
  EditMailingAddressPageProps,
  EditMailingAddressPage,
} from "./EditMailingAddressPage";
import { ContactInfoError, ContactInfoSkeleton } from "../../components";

export const EditMailingAddressPageWithSuspense =
  withSuspense<EditMailingAddressPageProps>(EditMailingAddressPage, {
    FallbackComponent: ContactInfoError,
    loading: <ContactInfoSkeleton rows={5} testId="edit-mailing-address" />,
  });
